import type { ComponentType } from '../../enums';
import { ActionType } from '../../enums';

type SortOrder = 'asc' | 'desc';

export interface CreateSortSelectEventPayloadOptions {
  componentType: ComponentType;
  componentVariant: string;
  pageType: string;
  sortField: string;
  sortOrder: SortOrder;
}

export interface CreateSortSelectEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    component_variant: string;
    page_type: string;
    sort_field: string;
    sort_order: SortOrder;
  };
}

export const createSortSelectEventPayload = ({
  componentType,
  pageType,
  componentVariant,
  sortField,
  sortOrder,
}: CreateSortSelectEventPayloadOptions): CreateSortSelectEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.SELECT,
      sort_field: sortField,
      sort_order: sortOrder,
      page_type: pageType,
      component_type: componentType,
      component_variant: componentVariant,
    },
  };
};
